module.exports = __webpack_public_path__ + "static/images/store-2.4af79a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/solution/store-2.png
// module id = ElYv
// module chunks = 8